import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_SGTEC_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterEtapas() {
        return axiosJwt
            .get(`${api}/sgtec/fornecedores/etapas/fornecedor`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    obterEtapasFaturadasNaoQuitadas() {
        return axiosJwt
            .get(`${api}/sgtec/fornecedores/etapas/EtapasFaturadasNaoQuitadas`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    obterEtapasPorVencimentos() {
        return axiosJwt
            .get(`${api}/sgtec/fornecedores/etapas/vencimentos`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    obterProjeto(projetoId) {
        return axiosJwt
            .get(`${api}/sgtec/fornecedores/projetos/${projetoId}`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    obterDespesas(etapaId) {
        return axiosJwt
            .get(`${api}/sgtec/fornecedores/etapas/${etapaId}/despesas`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    obterEtapa(etapaId) {
        return axiosJwt
            .get(`${api}/sgtec/fornecedores/etapas/${etapaId}`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    }
}
